import { useQuery } from '@tanstack/react-query';
import { getEntitlements } from '../settings/api';

/**
 * Whether this tenant's plan includes a feature.
 *
 * Plans are data, never `if (plan === 'PRO')` (context.md section 101), so the screen asks the
 * entitlements endpoint and reads the list it returns. The server enforces the gate regardless —
 * this only decides whether a control is offered, so that somebody is told before filling in a
 * form rather than after, and a plan changed in the control plane needs no deploy here.
 *
 * `undefined` while the answer is unknown: a screen that treats "not loaded yet" as "not allowed"
 * flashes an upsell at somebody who is entitled, which is worse than a moment of nothing.
 */
export function useFeature(feature: string): {
  allowed: boolean | undefined;
  planName: string | undefined;
} {
  const entitlements = useQuery({
    queryKey: ['entitlements'],
    queryFn: getEntitlements,
    staleTime: 5 * 60 * 1000,
  });

  return {
    allowed: entitlements.data ? entitlements.data.features.includes(feature) : undefined,
    planName: entitlements.data?.plan_name,
  };
}
